<template>
  <button class="main-btn" @click="openModal">
    {{ buttonTitle }}
  </button>
</template>

<script>
export default {
  data() {
    return {
      buttonTitle: "Оставить заявку",
    };
  },
  methods: {
    openModal() {
      this.modalOpened = true;
    },
    closeModal() {
      this.modalOpened = false;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/grid/grid";
.main-btn {
  position: relative;
  overflow: hidden;

  z-index: 1;
  @include adaptivWidthLg(536, 225);
  width: 100%;
  @include adaptivHeightlg(65, 40);
  background: #7338d8;
  color: #fff;
  @include adaptiv-fontlg(24, 14);
  @include adaptiv-lineHeightlg(24, 14);
  text-transform: uppercase;
  font-family: "Helvetica-thin";
  @include adaptivMarginlg(0, 0, 50, 0, 0, 0, 25, 0);
  &:hover {
    background: linear-gradient(90deg, #0250c5 0%, #d43f8d 100%);
    transition: background-color 2000s;
  }
  &::after {
    content: "";
    display: block;
    @include adaptivWidthLg(40, 20);
    width: 100%;
    height: 250px;
    margin-left: 50px;
    background: #fff;
    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0.2) 0%,
      rgba(255, 255, 255, 0.3) 50%,
      rgba(255, 255, 255, 0.2) 100%
    );

    backdrop-filter: blur(5px);
    left: -40px;
    top: -80px;
    z-index: 1;
    transform: rotate(45deg);
    position: absolute;
    animation: movingFlare 3s ease-in-out 0.05s infinite;
  }

  @keyframes movingFlare {
    0% {
      left: -30px;
      margin-left: 0px;
    }
    30% {
      left: 110%;
      margin-left: 80px;
    }
    100% {
      left: 110%;
      margin-left: 80px;
    }
  }
  @media (min-width: 1921px) {
    width: 600px;
  }
  @media (max-width: 768px) {
    @include adaptivWidthmd(248, 181);
    @include adaptivHeightmd(63, 46);
    @include adaptiv-fontmd(18, 16);
    @include adaptiv-lineHeightmd(18, 16);
    @include adaptivMarginmd(0, 0, 50, 0, 0, 0, 25, 0);
  }
}
</style>
